import { useEffect, useState } from 'react';
import { LogOut } from 'lucide-react';
import { logout, broadcastAuthChange } from '../../api/auth';
import { useStatus } from './StatusProvider';
import { APP_NAVIGATION_EVENT } from './navigationActions';
import { preloadRoute } from './routeLoaders';

const links = [
  ['/strong-v3', 'Strong V3'], ['/strong-v3-turns', '转折记录'], ['/behavior-pool', '当天机会'],
  ['/watchlist', '盯自选'], ['/structure-v2', '看走势'], ['/training', '练判断'],
  ['/ops-monitor', '运维'], ['/account', '账户'],
] as const;

export function AppNavigation() {
  const [path, setPath] = useState(location.pathname);
  const [busy, setBusy] = useState(false);
  const { notify } = useStatus();
  useEffect(() => {
    const update = () => setPath(location.pathname);
    window.addEventListener('popstate', update);
    window.addEventListener(APP_NAVIGATION_EVENT, update);
    return () => { window.removeEventListener('popstate', update); window.removeEventListener(APP_NAVIGATION_EVENT, update); };
  }, []);
  const signOut = async () => {
    setBusy(true);
    try {
      await logout();
      broadcastAuthChange();
      location.assign('/login');
    } catch (error) {
      notify(error instanceof Error ? error.message : '退出登录失败，请重试', 'error');
      setBusy(false);
    }
  };
  return <header className="relative z-40 border-b border-[#202633] bg-[#090c12]/95 px-3 py-2 backdrop-blur sm:px-5">
    <div className="flex min-h-10 flex-wrap items-center gap-3">
      <a href="/structure-v2" className="flex shrink-0 items-center gap-2 text-white"><span className="grid h-8 w-8 place-items-center rounded-lg border border-amber-500/40 text-lg text-amber-400">缠</span><strong className="text-sm">ChanHub</strong></a>
      <nav aria-label="主导航" className="order-3 grid w-full grid-cols-4 gap-1 lg:order-none lg:flex lg:w-auto lg:flex-1 lg:flex-wrap">
        {links.map(([href, label]) => <a key={href} href={href} onPointerEnter={() => preloadRoute(href)} onFocus={() => preloadRoute(href)} aria-current={path === href || (href === '/training' && path.startsWith('/training/')) ? 'page' : undefined}
          className={`whitespace-nowrap rounded-md px-2 py-2 text-center text-xs transition hover:bg-white/5 hover:text-white ${path === href || (href === '/training' && path.startsWith('/training/')) ? 'bg-blue-500/15 text-blue-300' : 'text-slate-400'}`}>{label}</a>)}
      </nav>
      <button type="button" onClick={signOut} disabled={busy} title="退出登录" aria-label="退出登录" className="grid h-8 w-8 shrink-0 place-items-center rounded-md text-slate-500 hover:bg-white/5 hover:text-white disabled:opacity-50"><LogOut className="h-4 w-4" /></button>
    </div>
  </header>;
}
